<template>
  <div class="signature-document-container">
    <template v-if="createMode">
      <b-icon
        v-if="document.documentId"
        icon-pack="fa"
        icon="check-circle"
        class="is-green-icon mr-2"
      />
      <b-icon
        v-else
        icon-pack="fa"
        icon="times-circle"
        class="is-red-icon mr-2"
      />
    </template>

    <label>{{ document.documentName }}</label>

    <div class="is-pulled-right" v-if="document.documentId">
      <span
        class="cursor-pointer"
        @click="downloadFile(document.documentId, document.documentName)"
      >
        <b-icon
          icon-pack="fa"
          icon="download"
          type="is-blue"
          class="mr-2"
        ></b-icon>
      </span>
    </div>

    <p class="mt-1 is-red-icon" v-if="!document.documentId">
      <label v-if="document.origin === 'GENERATED'">
        {{
          $t("bnpl:application.signature.modal.dynamic_documents.not_uploaded")
        }}
      </label>
      <label v-if="document.origin === 'FIX'">
        {{ $t("bnpl:application.signature.modal.fix_documents.not_uploaded") }}
      </label>
    </p>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import FileSaver from "file-saver";

export default {
  name: "BnplApplicationSignatureDocument",
  components: {},
  props: {
    document: {
      type: Object,
      required: true,
    },
    createMode: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    ...mapActions({
      download: "drawer/download",
    }),
    async downloadFile(documentId, filename) {
      await this.download(documentId);
      let blob = this.$store.getters["drawer/getFile"](documentId);
      FileSaver.saveAs(blob, filename);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/scss/colors";

.signature-document-container {
  border-bottom: 1px solid #cbd5e1;
  padding-bottom: 0.5rem;
}

.is-red-icon {
  color: $red;
}

.is-green-icon {
  color: $green;
}
</style>
